import { render, staticRenderFns } from "./historicalImportDetails.vue?vue&type=template&id=3f8b46c0&scoped=true"
import script from "./historicalImportDetails.vue?vue&type=script&lang=js"
export * from "./historicalImportDetails.vue?vue&type=script&lang=js"
import style0 from "./historicalImportDetails.vue?vue&type=style&index=0&id=3f8b46c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b46c0",
  null
  
)

export default component.exports